import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResumeState } from '../storage/resume.reducer';

export const selectResumeState = createFeatureSelector<ResumeState>('resume');

export const selectResumeData = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data
);

export const selectResumeError = createSelector(
    selectResumeState,
    (state: ResumeState) => state.error
);

export const selectResumeTenantData = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data ? state.data.Tenant : null
);

export const selectQuotePhoneList = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data ? state.data.quotePhoneList : null
);

export const selectQuoteId = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data ? state.data.quoteId : null
);

export const selectsessionId = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data ? state.data.sessionId : null
);

export const selectQuoteIdAndApplicationId = createSelector(
    selectResumeState,
    (state: ResumeState) => ({
        quoteId: state.data?.quoteId ?? null,
        ApplicationId: state.data?.quotePhoneList?.ApplicationId ?? state.data?.question?.ApplicationId ?? 0
    })
);
export const selectActivephone = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data ? state.data.quotePhoneList?.listPhones.find(phone => phone.isSelect)?.mobilePhoneNumber : null
);

export const selectCountResend = createSelector(
    selectResumeState,
    (state: ResumeState) => state.data ? state.data.countResend : null
);


export const selectQuestion = createSelector(selectResumeState, (state: ResumeState) => state.data ? state.data.question : undefined);